import { useState, useEffect } from "react";
import NavBar from "../Nav_Footer/NavBar";
import Footer from "../Nav_Footer/Footer";
import "./MainDashboard.scss";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BoatCard from "./BoatCard";
import EditBoatModal from "./EditBoatModal";
import AddBoatModal from "./AddBoatModal";
import QuickBookModal from "./QuickBookModal";
import EditTimeSlotsModal from "./EditTimeSlotsModal";
import HolidayModal from "./HolidayModal";
import AddDestinationModal from "./AddDestinationModal";
import AddAmenityModal from "./AddAmenityModal";
import ActivityCard from "./ActivityCard";
import AddActivityModal from "./AddActivityModal";
import VerifyBookingModal from "./VerifyBookingModal";

const BACKEND = process.env.REACT_APP_BACKEND;

function DashBoard() {
  // ── Bookings state ────────────────────────────────────────────────
  const [bookings, setBookings] = useState([]);
  const [verifyBooking, setVerifyBooking] = useState(null);
  const [classes, setClasses]   = useState([]);

  // ── Boats state ───────────────────────────────────────────────────
  const [boats, setBoats] = useState([]);

  // ── Settings ──────────────────────────────────────────────────────
  const [summerTime, setSummerTime] = useState(false);
  const [allTimeSlots, setAllTimeSlots] = useState([
    { label: 'Slot 1', start_time: '09:00', end_time: '12:00' },
    { label: 'Slot 2', start_time: '12:00', end_time: '17:30' },
    { label: 'Slot 3', start_time: '17:30', end_time: '20:40' },
  ]);
  const [allSummerTimeSlots, setAllSummerTimeSlots] = useState([
    { label: 'Slot 1', start_time: '09:00', end_time: '13:00' },
    { label: 'Slot 2', start_time: '13:00', end_time: '18:00' },
  ]);
  const [allHolidays, setAllHolidays] = useState([]);
  const [allGlobalDestinations, setAllGlobalDestinations] = useState([]);

  // ── Time Slot edit modal ───────────────────────────────────────────
  const [editTimeSlotsModal, setEditTimeSlotsModal] = useState(false);
  const [editTimeSlotsList, setEditTimeSlotsList] = useState([]);
  const [editSummerTimeSlotsList, setEditSummerTimeSlotsList] = useState([]);

  // ── Holiday modal ──────────────────────────────────────────────────
  const [holidayModalOpen, setHolidayModalOpen] = useState(false);
  const [holidayForm, setHolidayForm] = useState({
    holiday_name: "", start_date: "", end_date: "",
    pricing: {},
  });
  const [editingHolidayId, setEditingHolidayId] = useState(null);

  // ── Destination modal ──────────────────────────────────────────────
  const [destinationModalOpen, setDestinationModalOpen] = useState(false);
  const [newDestName, setNewDestName] = useState("");
  const [newDestSlotBased, setNewDestSlotBased] = useState(true);
  const [boatDestinationModal, setBoatDestinationModal] = useState(null);
  const [selectedDestIds, setSelectedDestIds] = useState([]);

  // ── Amenity modal ──────────────────────────────────────────────────
  const [allGlobalAmenities, setAllGlobalAmenities] = useState([]);
  const [amenityModalOpen, setAmenityModalOpen] = useState(false);
  const [newAmenityName, setNewAmenityName] = useState("");
  const [boatAmenityModal, setBoatAmenityModal] = useState(null);
  const [selectedAmenityIds, setSelectedAmenityIds] = useState([]);

  // ── Activities ────────────────────────────────────────────────────
  const [activities, setActivities] = useState([]);
  const [activityModalOpen, setActivityModalOpen] = useState(false);

  // ── Add boat modal ────────────────────────────────────────────────
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addForm, setAddForm]           = useState({ name: "", type: "", capacity: "" });
  const [addImages, setAddImages]       = useState([]);

  // ── Edit boat modal ───────────────────────────────────────────────
  const [editModal, setEditModal]   = useState(null); // boat object or null
  const [editTab, setEditTab]       = useState("info");
  const [editForm, setEditForm]     = useState(null);
  const [editImages, setEditImages] = useState([]);

  // ── Admin booking modal (quick-book from dashboard) ───────────────
  const [selectedBoat, setSelectedBoat] = useState(null);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [fullDay, setFullDay] = useState(false);
  const [slots, setSlots]     = useState({ slot1: false, slot2: false, slot3: false });
  const [bookingForm, setBookingForm] = useState({
    bookedBy: "", lastName: "", email: "", number: "",
    destination: "", date: "", slot1: false, slot2: false, slot3: false,
    code: "", status: "Admin", dropOff: false, money: 0,
  });

  const _now = new Date();
  const today = `${_now.getFullYear()}-${String(_now.getMonth() + 1).padStart(2, "0")}-${String(_now.getDate()).padStart(2, "0")}`;

  // Generate default pricing structure keyed by boat._id → destName → fields
  const generateDefaultPricing = () => {
    const pricing = {};
    boats.forEach((boat) => {
      pricing[boat._id] = {};
      (boat.destinations || []).forEach((dest) => {
        const destName = (dest.name || "").toLowerCase();
        const isSlotBased = dest.isSlotBased !== undefined ? dest.isSlotBased : true;
        pricing[boat._id][destName] = isSlotBased
          ? { slot1: 0, slot2: 0, slot3: 0, fullDay: 0, twoSlot: 0, summer_slot1: 0, summer_slot2: 0, summer_fullDay: 0 }
          : { full: 0, dropOff: 0, summer_full: 0, summer_dropOff: 0 };
      });
    });
    return pricing;
  };

  // ── Load all data ─────────────────────────────────────────────────
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    fetchBoats();
    fetchBoatBookings();
    fetchClassBookings();
    fetchSettings();
    fetchHolidays();
    fetchDestinations();
    fetchAmenities();
    fetchActivities();
  }, []);

  const fetchBoats = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/boats`);
      setBoats(res.data);
    } catch (err) {
      console.error("Error fetching boats:", err);
    }
  };

  const fetchBoatBookings = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/booking`);
      setBookings(res.data);
    } catch (err) {
      console.error("Error fetching bookings:", err);
    }
  };

  const fetchClassBookings = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/booking-class`);
      setClasses(res.data);
    } catch (err) {
      console.error("Error fetching classes:", err);
    }
  };

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/settings`);
      setSummerTime(res.data.summerTime);
      setAllTimeSlots(res.data.timeSlots && res.data.timeSlots.length > 0 ? res.data.timeSlots : [
        { label: 'Slot 1', start_time: '09:00', end_time: '12:00' },
        { label: 'Slot 2', start_time: '12:00', end_time: '17:30' },
        { label: 'Slot 3', start_time: '17:30', end_time: '20:40' },
      ]);
      setAllSummerTimeSlots(res.data.summerTimeSlots && res.data.summerTimeSlots.length > 0 ? res.data.summerTimeSlots : [
        { label: 'Slot 1', start_time: '09:00', end_time: '13:00' },
        { label: 'Slot 2', start_time: '13:00', end_time: '18:00' },
      ]);
      console.log('[DEBUG] fetchSettings result:', { timeSlots: res.data.timeSlots, summerTimeSlots: res.data.summerTimeSlots });
    } catch (err) {
      console.error("Error fetching settings:", err);
    }
  };

  const fetchHolidays = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/holidays`);
      setAllHolidays(res.data);
    } catch (err) {
      console.error("Error fetching holidays:", err);
    }
  };

  const fetchDestinations = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/destinations`);
      setAllGlobalDestinations(res.data);
    } catch (err) {
      console.error("Error fetching destinations:", err);
    }
  };

  const fetchAmenities = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/amenities`);
      setAllGlobalAmenities(res.data);
    } catch (err) {
      console.error("Error fetching amenities:", err);
    }
  };

  const fetchActivities = async () => {
    try {
      const res = await axios.get(`${BACKEND}/api/activities`);
      setActivities(res.data);
    } catch (err) {
      console.error("Error fetching activities:", err);
    }
  };

  // ── Toast helpers ─────────────────────────────────────────────────
  const notifySuccess = (msg) =>
    toast.success(msg, { position: "top-right", autoClose: 3000, hideProgressBar: true, theme: "dark" });
  const notifyFailure = (msg) =>
    toast.error(msg,  { position: "top-right", autoClose: 3000, hideProgressBar: true, theme: "dark" });

  // ── Helpers ───────────────────────────────────────────────────────
  const formatReadableDate = (dateString) =>
    new Date(dateString).toLocaleString("en-US", {
      year: "numeric", month: "long", day: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
      timeZone: "Africa/Cairo",
    });

  const formatTime12Hour = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const slotText = (slot1, slot2, slot3) => {
    if (slot1 && slot2 && (slot3 || summerTime)) return "Full day trip";
    const parts = [];
    if (slot1) parts.push("9:00 AM–12:00 PM");
    if (slot2) parts.push("12:00 PM–5:30 PM");
    if (slot3) parts.push("3:40 PM–6:40 PM");
    return parts.join(", ") || "-";
  };

  const getBookingTimeText = (slot1, slot2, slot3) => {
    const activeSlots = summerTime ? allSummerTimeSlots : allTimeSlots;
    const selectedIndices = [];
    if (slot1) selectedIndices.push(0);
    if (slot2) selectedIndices.push(1);
    if (!summerTime && slot3) selectedIndices.push(2);
    if (selectedIndices.length === 0) return "";
    const fmt = (time) => {
      const [h, m] = time.split(":");
      const hour = parseInt(h);
      const ampm = hour >= 12 ? "PM" : "AM";
      return `${hour % 12 || 12}:${m} ${ampm}`;
    };
    const first = activeSlots[selectedIndices[0]];
    const last = activeSlots[selectedIndices[selectedIndices.length - 1]];
    if (!first || !last) return "";
    return `${fmt(first.start_time)} – ${fmt(last.end_time)}`;
  };

  // ── Summer time toggle ────────────────────────────────────────────
  const handleSummerTimeToggle = async () => {
    const newVal = !summerTime;
    setSummerTime(newVal);
    try {
      await axios.patch(`${BACKEND}/api/settings`, { summerTime: newVal });
      notifySuccess(`Summer time ${newVal ? "enabled" : "disabled"}`);
    } catch {
      setSummerTime(!newVal);
      notifyFailure("Failed to update settings");
    }
  };

  // ── Boat availability toggle ──────────────────────────────────────
  const handleToggle = async (boatId, currentStatus) => {
    const newStatus = currentStatus === "available" ? "unavailable" : "available";
    setBoats((prev) => prev.map((b) => b._id === boatId ? { ...b, status: newStatus } : b));
    try {
      await axios.patch(`${BACKEND}/api/boats/${newStatus}/${boatId}`);
      notifySuccess(`Boat marked as ${newStatus}`);
    } catch {
      setBoats((prev) => prev.map((b) => b._id === boatId ? { ...b, status: currentStatus } : b));
      notifyFailure("Failed to update boat status");
    }
  };

  // ── Delete boat ───────────────────────────────────────────────────
  const handleDeleteBoat = async (id) => {
    if (!window.confirm("Delete this boat? This cannot be undone.")) return;
    try {
      await axios.delete(`${BACKEND}/api/boats/${id}`);
      setBoats((prev) => prev.filter((b) => b._id !== id));
      notifySuccess("Boat deleted");
    } catch {
      notifyFailure("Failed to delete boat");
    }
  };

  // ── Edit modal ────────────────────────────────────────────────────
  const openEditModal = (boat) => {
    setEditTab("info");
    setEditImages([]);

    // Convert boat.pricing to plain object (in case it's a Mongoose subdocument)
    const boatPricingPlain = boat.pricing ? JSON.parse(JSON.stringify(boat.pricing)) : {};
    const boatSummerPricingPlain = boat.summerPricing ? JSON.parse(JSON.stringify(boat.summerPricing)) : {};

    // Build pricing objects from boat's actual destinations
    const pricing = {};
    const summerPricing = {};

    // Initialize pricing for all assigned destinations
    if (boat.destinations && boat.destinations.length > 0) {
      boat.destinations.forEach((dest) => {
        const destName = dest.name ? dest.name.toLowerCase() : '';
        const isSlotBased = dest.isSlotBased !== undefined ? dest.isSlotBased : true;

        // Initialize normal season pricing with correct structure based on slot type
        if (isSlotBased) {
          pricing[destName] = {
            slot1: boatPricingPlain[destName]?.slot1 || 0,
            slot2: boatPricingPlain[destName]?.slot2 || 0,
            slot3: boatPricingPlain[destName]?.slot3 || 0,
            fullDay: boatPricingPlain[destName]?.fullDay || 0,
            twoSlot: boatPricingPlain[destName]?.twoSlot || 0,
          };
          // Initialize summer season pricing (2 slots instead of 3)
          summerPricing[destName] = {
            slot1: boatSummerPricingPlain[destName]?.slot1 || 0,
            slot2: boatSummerPricingPlain[destName]?.slot2 || 0,
            fullDay: boatSummerPricingPlain[destName]?.fullDay || 0,
            twoSlot: boatSummerPricingPlain[destName]?.twoSlot || 0,
          };
        } else {
          pricing[destName] = {
            full: boatPricingPlain[destName]?.full || 0,
            dropOff: boatPricingPlain[destName]?.dropOff || 0,
          };
          summerPricing[destName] = {
            full: boatSummerPricingPlain[destName]?.full || 0,
            dropOff: boatSummerPricingPlain[destName]?.dropOff || 0,
          };
        }
      });
    }

    console.log('[INFO] openEditModal pricing:', pricing, 'summerPricing:', summerPricing);

    setEditForm({
      _id: boat._id,
      name: boat.name,
      type: boat.type,
      capacity: boat.capacity,
      pricing,
      summerPricing,
    });
    setEditModal(boat);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePricingChange = (dest, field, value) => {
    setEditForm((prev) => ({
      ...prev,
      pricing: {
        ...prev.pricing,
        [dest]: { ...prev.pricing[dest], [field]: Number(value) },
      },
    }));
  };

  const handleSummerPricingChange = (dest, field, value) => {
    setEditForm((prev) => ({
      ...prev,
      summerPricing: {
        ...prev.summerPricing,
        [dest]: { ...prev.summerPricing[dest], [field]: Number(value) },
      },
    }));
  };

  const handleSaveEdit = async () => {
    try {
      // Ensure pricing is complete
      if (!editForm.pricing || Object.keys(editForm.pricing).length === 0) {
        notifyFailure("No pricing data to save");
        return;
      }

      const data = new FormData();
      data.append("name",     editForm.name);
      data.append("type",     editForm.type);
      data.append("capacity", editForm.capacity);

      const pricingString = JSON.stringify(editForm.pricing);
      const summerPricingString = JSON.stringify(editForm.summerPricing || {});
      console.log('[INFO] Saving boat pricing:', pricingString, 'summerPricing:', summerPricingString);
      data.append("pricing",  pricingString);
      data.append("summerPricing", summerPricingString);
      editImages.forEach((img) => data.append("images", img));

      const res = await axios.put(`${BACKEND}/api/boats/${editForm._id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log('[INFO] Boat updated response:', res.data.boat);
      setBoats((prev) => prev.map((b) => b._id === editForm._id ? res.data.boat : b));
      setEditModal(null);
      notifySuccess("Boat updated successfully");
    } catch (error) {
      console.error('[ERROR] Failed to update boat:', error);
      notifyFailure("Failed to update boat: " + (error.response?.data?.message || error.message));
    }
  };

  // ── Add modal ─────────────────────────────────────────────────────
  const handleAddBoat = async () => {
    if (!addForm.name || !addForm.type || !addForm.capacity) {
      notifyFailure("Please fill in all fields");
      return;
    }
    try {
      const data = new FormData();
      data.append("name",     addForm.name);
      data.append("type",     addForm.type);
      data.append("capacity", addForm.capacity);
      data.append("status",   "available");
      addImages.forEach((img) => data.append("images", img));

      const res = await axios.post(`${BACKEND}/api/boats`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setBoats((prev) => [...prev, res.data.boat]);
      setAddModalOpen(false);
      setAddForm({ name: "", type: "", capacity: "" });
      setAddImages([]);
      notifySuccess("Boat added");
    } catch {
      notifyFailure("Failed to add boat");
    }
  };

  // ── ID verification ───────────────────────────────────────────────
  const needsIdAction = (b) =>
    b.verification?.status === "awaiting" || b.refund?.status === "failed";

  const awaitingCount = bookings.filter(
    (b) => needsIdAction(b) && new Date(b.date) >= new Date(today)
  ).length;

  const verificationBadgeText = (b) => {
    if (b.refund?.status === "failed") return "Refund failed";
    if (b.verification?.status === "awaiting") return "ID check needed";
    if (b.verification?.status === "approved") return "IDs approved";
    if (b.verification?.status === "declined") {
      return b.refund?.status === "succeeded" ? "Declined, refunded" : "Declined, refund pending";
    }
    return "Outside guests";
  };

  const handleVerificationUpdated = (updated) => {
    setBookings((prev) => prev.map((b) => (b._id === updated._id ? updated : b)));
    setVerifyBooking(updated);
  };

  // ── Booking handlers (existing) ───────────────────────────────────
  const handleDelete = async (type, id) => {
    try {
      if (type === "boat") {
        await axios.delete(`${BACKEND}/api/booking/${id}`);
        setBookings((prev) => prev.filter((b) => b._id !== id));
      } else {
        await axios.delete(`${BACKEND}/api/booking-class/${id}`);
        setClasses((prev) => prev.filter((b) => b._id !== id));
      }
      notifySuccess("Booking deleted");
    } catch (error) {
      notifyFailure(error.message);
    }
  };

  const openBookingModal = (boat) => {
    setSelectedBoat(boat);
    setBookingModalOpen(true);
  };

  const closeBookingModal = () => {
    setBookingModalOpen(false);
    setSelectedBoat(null);
    setSlots({ slot1: false, slot2: false, slot3: false });
    setFullDay(false);
    setBookingForm({
      bookedBy: "", lastName: "", email: "", number: "",
      destination: "", date: "", slot1: false, slot2: false, slot3: false,
      code: "", status: "Admin", dropOff: false, money: 0,
    });
  };

  const handleBookingChange = (e) => {
    const { name, value, type, checked } = e.target;
    setBookingForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleBookingDateChange = async (e) => {
    const { name, value } = e.target;
    setBookingForm((prev) => ({ ...prev, [name]: value, slot1: false, slot2: false, slot3: false }));

    const newDate        = name === "date"        ? value : bookingForm.date;
    const newDestination = name === "destination" ? value : bookingForm.destination;
    if (!newDate) return;

    try {
      const { data } = await axios.get(
        `${BACKEND}/api/booking/available/${selectedBoat.name}/${newDate}`
      );

      const destObj = allGlobalDestinations.find((d) => d.name === newDestination);
      const isSlotBased = destObj ? (destObj.isSlotBased !== undefined ? destObj.isSlotBased : true) : newDestination === "Bayoud";

      const _now = new Date();
      const todayStr = `${_now.getFullYear()}-${String(_now.getMonth() + 1).padStart(2, "0")}-${String(_now.getDate()).padStart(2, "0")}`;
      const isSlotPastForDate = (slotNum) => {
        if (newDate !== todayStr) return false;
        const activeSlots = summerTime ? allSummerTimeSlots : allTimeSlots;
        const slot = activeSlots[slotNum - 1];
        if (!slot) return false;
        const now = new Date();
        const [h, m] = slot.start_time.split(':').map(Number);
        const slotStart = new Date();
        slotStart.setHours(h, m, 0, 0);
        return now > slotStart;
      };

      if (isSlotBased) {
        setSlots({ slot1: data.slot1, slot2: data.slot2, slot3: data.slot3 });
      } else {
        const s1 = data.slot1 && !isSlotPastForDate(1);
        const s2 = data.slot2 && !isSlotPastForDate(2);
        const s3 = data.slot3 && !isSlotPastForDate(3);
        const allAvailable = summerTime ? (s1 && s2) : (s1 && s2 && s3);

        if (allAvailable) {
          setFullDay(true);
          setSlots(data);
          setBookingForm((prev) => ({
            ...prev,
            slot1: true, slot2: true, slot3: summerTime ? false : true,
          }));
        } else {
          setFullDay(false);
          setSlots({ slot1: false, slot2: false, slot3: false });
        }
      }
    } catch {
      notifyFailure("Failed to load slots, please refresh");
    }
  };

  const isBookingFormValid = () => {
    if (!bookingForm.bookedBy || !bookingForm.destination || !bookingForm.date) return false;
    const destObj = allGlobalDestinations.find((d) => d.name === bookingForm.destination);
    const isSlotBased = destObj ? (destObj.isSlotBased !== undefined ? destObj.isSlotBased : true) : bookingForm.destination === "Bayoud";
    if (isSlotBased) return !!(bookingForm.slot1 || bookingForm.slot2 || bookingForm.slot3);
    return fullDay;
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BACKEND}/api/booking`, {
        boatID:      selectedBoat._id,
        boatName:    selectedBoat.name,
        date:        bookingForm.date,
        bookedBy:    `${bookingForm.bookedBy} ${bookingForm.lastName}`,
        email:       bookingForm.email,
        code:        bookingForm.code,
        number:      bookingForm.number,
        destination: bookingForm.destination,
        slot1:       bookingForm.slot1,
        slot2:       bookingForm.slot2,
        slot3:       bookingForm.slot3,
        dropOff:     bookingForm.dropOff,
        status:      "Admin",
      });
      await axios.post(`${BACKEND}/api/util/append_sheet`, {
        values: [
          selectedBoat.name, bookingForm.date, bookingForm.bookedBy, bookingForm.lastName,
          bookingForm.email, bookingForm.code, bookingForm.number, bookingForm.destination,
          getBookingTimeText(bookingForm.slot1, bookingForm.slot2, bookingForm.slot3),
          bookingForm.dropOff, bookingForm.money, bookingForm.money * 0.25,
        ],
      });
      await fetchBoatBookings();
      notifySuccess("Booking successful");
      closeBookingModal();
    } catch {
      notifyFailure("Booking failed");
    }
  };

  const validDestinations = (boat) => {
    if (!boat || !boat.destinations || boat.destinations.length === 0) return [];
    return boat.destinations.map((d) => d.name || d);
  };

  // ── Time Slot handlers ────────────────────────────────────────────
  const openEditTimeSlotsModal = () => {
    console.log('[DEBUG] Opening slots modal. allTimeSlots:', allTimeSlots, 'allSummerTimeSlots:', allSummerTimeSlots);
    setEditTimeSlotsList(JSON.parse(JSON.stringify(allTimeSlots || [])));
    setEditSummerTimeSlotsList(JSON.parse(JSON.stringify(allSummerTimeSlots || [])));
    setEditTimeSlotsModal(true);
  };

  const handleTimeSlotChange = (idx, field, value) => {
    setEditTimeSlotsList((prev) => {
      const updated = [...prev];
      updated[idx] = { ...updated[idx], [field]: value };
      return updated;
    });
  };

  const saveTimeSlots = async () => {
    try {
      await axios.patch(`${BACKEND}/api/settings`, {
        timeSlots: editTimeSlotsList,
        summerTimeSlots: editSummerTimeSlotsList
      });
      setAllTimeSlots(editTimeSlotsList);
      setAllSummerTimeSlots(editSummerTimeSlotsList);
      setEditTimeSlotsModal(false);
      notifySuccess("Time slots updated");
    } catch {
      notifyFailure("Failed to update time slots");
    }
  };

  // ── Holiday handlers ──────────────────────────────────────────────
  const openHolidayModal = (holiday = null) => {
    if (holiday) {
      setHolidayForm(JSON.parse(JSON.stringify(holiday)));
      setEditingHolidayId(holiday._id);
    } else {
      setHolidayForm({
        holiday_name: "", start_date: "", end_date: "",
        pricing: generateDefaultPricing(),
      });
      setEditingHolidayId(null);
    }
    setHolidayModalOpen(true);
  };

  const handleHolidayFormChange = (e) => {
    const { name, value } = e.target;
    setHolidayForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleHolidayPricingChange = (boatId, dest, field, value) => {
    setHolidayForm((prev) => ({
      ...prev,
      pricing: {
        ...prev.pricing,
        [boatId]: {
          ...(prev.pricing[boatId] || {}),
          [dest]: { ...(prev.pricing[boatId]?.[dest] || {}), [field]: Number(value) },
        },
      },
    }));
  };

  const saveHoliday = async () => {
    if (!holidayForm.holiday_name || !holidayForm.start_date || !holidayForm.end_date) {
      notifyFailure("Please fill in all required fields");
      return;
    }
    try {
      if (editingHolidayId) {
        await axios.put(`${BACKEND}/api/holidays/${editingHolidayId}`, holidayForm);
        notifySuccess("Holiday updated");
      } else {
        await axios.post(`${BACKEND}/api/holidays`, holidayForm);
        notifySuccess("Holiday created");
      }
      await fetchHolidays();
      setHolidayModalOpen(false);
    } catch {
      notifyFailure("Failed to save holiday");
    }
  };

  const deleteHoliday = async (id) => {
    if (!window.confirm("Delete this holiday rule?")) return;
    try {
      await axios.delete(`${BACKEND}/api/holidays/${id}`);
      await fetchHolidays();
      notifySuccess("Holiday deleted");
    } catch {
      notifyFailure("Failed to delete holiday");
    }
  };

  // ── Destination handlers ───────────────────────────────────────────
  const openBoatDestinationModal = (boat) => {
    const destIds = boat.destinations ? boat.destinations.map((d) => d._id || d) : [];
    setSelectedDestIds(destIds);
    setBoatDestinationModal(boat);
  };

  const toggleBoatDestination = (destId) => {
    setSelectedDestIds((prev) =>
      prev.includes(destId) ? prev.filter((d) => d !== destId) : [...prev, destId]
    );
  };

  const saveBoatDestinations = async () => {
    try {
      await axios.patch(`${BACKEND}/api/destinations/boats/${boatDestinationModal._id}`, {
        destinationIds: selectedDestIds,
      });
      await fetchBoats();
      setBoatDestinationModal(null);
      notifySuccess("Boat destinations updated");
    } catch {
      notifyFailure("Failed to update boat destinations");
    }
  };

  const createDestination = async () => {
    if (!newDestName) {
      notifyFailure("Please enter a destination name");
      return;
    }
    try {
      await axios.post(`${BACKEND}/api/destinations`, {
        name: newDestName,
        isSlotBased: newDestSlotBased,
      });
      setNewDestName("");
      setNewDestSlotBased(true);
      await fetchDestinations();
      notifySuccess("Destination created");
    } catch {
      notifyFailure("Failed to create destination");
    }
  };

  const deleteDestination = async (id) => {
    if (!window.confirm("Delete this destination?")) return;
    try {
      await axios.delete(`${BACKEND}/api/destinations/${id}`);
      await fetchDestinations();
      notifySuccess("Destination deleted");
    } catch (err) {
      notifyFailure(err.response?.data?.message || "Failed to delete destination");
    }
  };

  // ── Amenity handlers ───────────────────────────────────────────────
  const openBoatAmenityModal = (boat) => {
    const amenityIds = boat.amenities ? boat.amenities.map((a) => a._id || a) : [];
    setSelectedAmenityIds(amenityIds);
    setBoatAmenityModal(boat);
  };

  const toggleBoatAmenity = (amenityId) => {
    setSelectedAmenityIds((prev) =>
      prev.includes(amenityId) ? prev.filter((a) => a !== amenityId) : [...prev, amenityId]
    );
  };

  const saveBoatAmenities = async () => {
    try {
      await axios.patch(`${BACKEND}/api/amenities/boats/${boatAmenityModal._id}`, {
        amenityIds: selectedAmenityIds,
      });
      await fetchBoats();
      setBoatAmenityModal(null);
      notifySuccess("Boat amenities updated");
    } catch {
      notifyFailure("Failed to update boat amenities");
    }
  };

  const createAmenity = async () => {
    if (!newAmenityName.trim()) {
      notifyFailure("Please enter an amenity name");
      return;
    }
    try {
      await axios.post(`${BACKEND}/api/amenities`, { name: newAmenityName.trim() });
      setNewAmenityName("");
      await fetchAmenities();
      notifySuccess("Amenity created");
    } catch {
      notifyFailure("Failed to create amenity");
    }
  };

  const deleteAmenity = async (id) => {
    if (!window.confirm("Delete this amenity?")) return;
    try {
      await axios.delete(`${BACKEND}/api/amenities/${id}`);
      await fetchAmenities();
      notifySuccess("Amenity deleted");
    } catch (err) {
      notifyFailure(err.response?.data?.message || "Failed to delete amenity");
    }
  };


  // ─────────────────────────────────────────────────────────────────
  return (
    <>
      <NavBar />
      <div className="dashboard-container">
        <h1 className="page-title">Admin Dashboard</h1>

        {/* ── Settings ── */}
        <section className="admin-section">
          <h2>Settings</h2>
          <div className="settings-grid">
            <div className="setting-item">
              <div className="setting-label">
                <span>Summer Time</span>
                <small>2 slots only</small>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={summerTime}
                  onChange={handleSummerTimeToggle}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </section>

        {/* ── Boat Management ── */}
        <section className="admin-section">
          <div className="section-header">
            <h2>Boats</h2>
            <button className="add-btn" onClick={() => setAddModalOpen(true)}>+ Add Boat</button>
          </div>
          <div className="boats">
            {boats.map((boat) => (
              <BoatCard
                key={boat._id}
                boat={boat}
                onToggle={handleToggle}
                onEdit={openEditModal}
                onBook={openBookingModal}
                onDelete={handleDeleteBoat}
              />
            ))}
          </div>
        </section>

        {/* ── Boat Bookings ── */}
        <section className="admin-section">
          <h2>
            Boat Bookings
            {awaitingCount > 0 && (
              <span className="verify-count">{awaitingCount} need ID review</span>
            )}
          </h2>
          <div className="booking-section">
            {bookings.length > 0 ? (
              bookings
                .filter((b) => new Date(b.date) >= new Date(today))
                // Bookings waiting on an ID decision float to the top
                .sort((a, b) =>
                  (needsIdAction(b) - needsIdAction(a)) || (new Date(a.date) - new Date(b.date)))
                .map((booking) => (
                  <div key={booking._id}
                    className={`booking-card ${needsIdAction(booking) ? "needs-verification" : ""}`}>
                    {booking.needsReview && (
                      <span className="verify-badge data-review" title={booking.reviewReason}>
                        <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                        Check booking details
                      </span>
                    )}
                    {booking.outsideGuests && (
                      <span className={`verify-badge ${booking.verification?.status} refund-${booking.refund?.status || "none"}`}>
                        <i className="fa-solid fa-id-card" aria-hidden="true"></i>
                        {verificationBadgeText(booking)}
                      </span>
                    )}
                    <h2>{booking.boatName}</h2>
                    <p><strong>Name:</strong> {booking.bookedBy}</p>
                    {booking.needsReview && (
                      <p><strong>Saved with errors:</strong> {booking.reviewReason}</p>
                    )}
                    <p><strong>Code:</strong> {booking.code}</p>
                    <p><strong>Email:</strong> {booking.email}</p>
                    <p><strong>Number:</strong> {booking.number}</p>
                    <p><strong>Destination:</strong> {booking.destination}</p>
                    <p><strong>Date:</strong> {booking.date}</p>
                    <p><strong>Booked at:</strong> {formatReadableDate(booking.createdAt)}</p>
                    <p><strong>Drop off:</strong> {String(booking.dropOff)}</p>
                    <p><strong>Booked by:</strong> {booking.status}</p>
                    <p><strong>Slots:</strong> {slotText(booking.slot1, booking.slot2, booking.slot3)}</p>
                    {booking.outsideGuests && (
                      <button className="edit-btn verify-open-btn" onClick={() => setVerifyBooking(booking)}>
                        {needsIdAction(booking) ? "Review IDs" : "View verification"}
                      </button>
                    )}
                    <button className="decline-btn" onClick={() => handleDelete("boat", booking._id)}>
                      Delete
                    </button>
                  </div>
                ))
            ) : (
              <p className="noBooking">No boat bookings available</p>
            )}
          </div>
        </section>

        {/* ── Class Bookings ── */}
        <section className="admin-section">
          <h2>Sailing Class Bookings</h2>
          <div className="booking-section">
            {classes.filter((b) => new Date(b.date) >= new Date(today)).length > 0 ? (
              classes
                .filter((b) => new Date(b.date) >= new Date(today))
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((booking) => (
                  <div key={booking._id} className="booking-card">
                    <p><strong>ID:</strong> {booking._id}</p>
                    <p><strong>Booked by:</strong> {booking.bookedBy}</p>
                    <p><strong>Email:</strong> {booking.email}</p>
                    <p><strong>Number:</strong> {booking.number}</p>
                    <p><strong>Date:</strong> {booking.date}</p>
                    <p><strong>Booked at:</strong> {formatReadableDate(booking.createdAt)}</p>
                    <p><strong>Age:</strong> {booking.age}</p>
                    <p><strong>Status:</strong> {booking.status}</p>
                  </div>
                ))
            ) : (
              <p className="noBooking">No sailing class bookings available</p>
            )}
          </div>
        </section>

        {/* ── Time Slots ── */}
        <section className="admin-section">
          <div className="section-header">
            <h2>Time Slots</h2>
            <button className="add-btn" onClick={openEditTimeSlotsModal}>Edit Slots</button>
          </div>
          <div className="time-slots-list">
            {(allTimeSlots && allTimeSlots.length > 0) || (allSummerTimeSlots && allSummerTimeSlots.length > 0) ? (
              <>
                {allTimeSlots && allTimeSlots.length > 0 && (
                  <table>
                    <thead>
                      <tr>
                        <th>Normal Season</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allTimeSlots.map((slot, idx) => (
                        <tr key={`normal-${idx}`}>
                          <td data-label="Slot">{slot.label}</td>
                          <td data-label="Start Time">{formatTime12Hour(slot.start_time)}</td>
                          <td data-label="End Time">{formatTime12Hour(slot.end_time)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {allSummerTimeSlots && allSummerTimeSlots.length > 0 && (
                  <table>
                    <thead>
                      <tr>
                        <th>Summer Season</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allSummerTimeSlots.map((slot, idx) => (
                        <tr key={`summer-${idx}`}>
                          <td data-label="Slot">{slot.label}</td>
                          <td data-label="Start Time">{formatTime12Hour(slot.start_time)}</td>
                          <td data-label="End Time">{formatTime12Hour(slot.end_time)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </>
            ) : (
              <p>No time slots configured</p>
            )}
          </div>
        </section>

        {/* ── Holiday Pricing ── */}
        <section className="admin-section">
          <div className="section-header">
            <h2>Holiday Pricing Rules</h2>
            <button className="add-btn" onClick={() => openHolidayModal()}>+ Add Holiday</button>
          </div>
          <div className="holidays-list">
            {allHolidays && allHolidays.length > 0 ? (
              allHolidays.map((holiday) => (
                <div key={holiday._id} className="holiday-card">
                  <div className="holiday-info">
                    <h3>{holiday.holiday_name}</h3>
                    <p>
                      <strong>Date Range:</strong> {new Date(holiday.start_date).toLocaleDateString()} – {new Date(holiday.end_date).toLocaleDateString()}
                    </p>
                  </div>
                  <div className="holiday-actions">
                    <button className="edit-btn" onClick={() => openHolidayModal(holiday)}>Edit</button>
                    <button className="delete-btn" onClick={() => deleteHoliday(holiday._id)}>Delete</button>
                  </div>
                </div>
              ))
            ) : (
              <p>No holiday rules configured</p>
            )}
          </div>
        </section>

        {/* ── Destinations ── */}
        <section className="admin-section">
          <div className="section-header">
            <h2>Destinations</h2>
            <button className="add-btn" onClick={() => setDestinationModalOpen(true)}>+ Add Destination</button>
          </div>
          <div className="destinations-list">
            {allGlobalDestinations && allGlobalDestinations.length > 0 ? (
              <>
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allGlobalDestinations.map((dest) => (
                      <tr key={dest._id}>
                        <td data-label="Name">{dest.name}</td>
                        <td data-label="Type">{dest.isSlotBased ? "Slot-based" : "Full-day only"}</td>
                        <td data-label="Actions">
                          <button className="delete-btn" onClick={() => deleteDestination(dest._id)}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <h4>Assign Destinations to Boats</h4>
                <div className="boats">
                  {boats.map((boat) => (
                    <div key={boat._id} className="dest-boat-card">
                      <h3>{boat.name}</h3>
                      <p className="boat-meta">{boat.type} · {boat.capacity} pax</p>
                      <p className="boat-destinations"><strong>Assigned:</strong> {boat.destinations && boat.destinations.length > 0 ? boat.destinations.map((d) => d.name || d).join(", ") : "None"}</p>
                      <button className="edit-btn" onClick={() => openBoatDestinationModal(boat)}>Manage Destinations</button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <p>No destinations configured</p>
            )}
          </div>
        </section>

        {/* ── Amenities ── */}
        <section className="admin-section">
          <div className="section-header">
            <h2>Amenities</h2>
            <button className="add-btn" onClick={() => setAmenityModalOpen(true)}>+ Add Amenity</button>
          </div>
          <div className="destinations-list">
            {allGlobalAmenities && allGlobalAmenities.length > 0 ? (
              <>
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allGlobalAmenities.map((amenity) => (
                      <tr key={amenity._id}>
                        <td data-label="Name">{amenity.name}</td>
                        <td data-label="Actions">
                          <button className="delete-btn" onClick={() => deleteAmenity(amenity._id)}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <h4>Assign Amenities to Boats</h4>
                <div className="boats">
                  {boats.map((boat) => (
                    <div key={boat._id} className="dest-boat-card">
                      <h3>{boat.name}</h3>
                      <p className="boat-meta">{boat.type} · {boat.capacity} pax</p>
                      <p className="boat-destinations"><strong>Amenities:</strong> {boat.amenities && boat.amenities.length > 0 ? boat.amenities.map((a) => a.name || a).join(", ") : "None"}</p>
                      <button className="edit-btn" onClick={() => openBoatAmenityModal(boat)}>Manage Amenities</button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <p>No amenities configured</p>
            )}
          </div>
        </section>

        {/* ── Activities ── */}
        <section className="admin-section">
          <div className="section-header">
            <h2>Activities</h2>
            <button className="add-btn" onClick={() => setActivityModalOpen(true)}>Manage Activities</button>
          </div>
          <div className="boats">
            {activities.length > 0 ? (
              activities.map((a) => (
                <ActivityCard key={a._id} activity={a} />
              ))
            ) : (
              <p>No activities yet</p>
            )}
          </div>
        </section>
      </div>

      <EditBoatModal
        editModal={editModal}
        editForm={editForm}
        editTab={editTab}
        editImages={editImages}
        allTimeSlots={allTimeSlots}
        allSummerTimeSlots={allSummerTimeSlots}
        setEditTab={setEditTab}
        setEditImages={setEditImages}
        handleEditFormChange={handleEditFormChange}
        handlePricingChange={handlePricingChange}
        handleSummerPricingChange={handleSummerPricingChange}
        onClose={() => setEditModal(null)}
        onSaveEdit={handleSaveEdit}
      />

      <AddBoatModal
        addModalOpen={addModalOpen}
        addForm={addForm}
        addImages={addImages}
        setAddForm={setAddForm}
        setAddImages={setAddImages}
        onClose={() => setAddModalOpen(false)}
        onAddBoat={handleAddBoat}
      />

      <QuickBookModal
        bookingModalOpen={bookingModalOpen}
        selectedBoat={selectedBoat}
        bookingForm={bookingForm}
        slots={slots}
        fullDay={fullDay}
        summerTime={summerTime}
        today={today}
        onClose={closeBookingModal}
        onBookingChange={handleBookingChange}
        onBookingDateChange={handleBookingDateChange}
        isBookingFormValid={isBookingFormValid}
        onBookingSubmit={handleBookingSubmit}
        setBookingForm={setBookingForm}
        destinations={selectedBoat ? validDestinations(selectedBoat) : []}
        allTimeSlots={allTimeSlots}
        allSummerTimeSlots={allSummerTimeSlots}
        allGlobalDestinations={allGlobalDestinations}
      />

      <EditTimeSlotsModal
        editTimeSlotsModal={editTimeSlotsModal}
        editTimeSlotsList={editTimeSlotsList}
        editSummerTimeSlotsList={editSummerTimeSlotsList}
        setEditSummerTimeSlotsList={setEditSummerTimeSlotsList}
        handleTimeSlotChange={handleTimeSlotChange}
        onClose={() => setEditTimeSlotsModal(false)}
        onSaveTimeSlots={saveTimeSlots}
      />

      <HolidayModal
        holidayModalOpen={holidayModalOpen}
        editingHolidayId={editingHolidayId}
        holidayForm={holidayForm}
        boats={boats}
        allTimeSlots={allTimeSlots}
        allSummerTimeSlots={allSummerTimeSlots}
        handleHolidayFormChange={handleHolidayFormChange}
        handleHolidayPricingChange={handleHolidayPricingChange}
        onClose={() => setHolidayModalOpen(false)}
        onSaveHoliday={saveHoliday}
      />

      <AddDestinationModal
        destinationModalOpen={destinationModalOpen}
        newDestName={newDestName}
        newDestSlotBased={newDestSlotBased}
        boatDestinationModal={boatDestinationModal}
        selectedDestIds={selectedDestIds}
        allGlobalDestinations={allGlobalDestinations}
        setNewDestName={setNewDestName}
        setNewDestSlotBased={setNewDestSlotBased}
        setBoatDestinationModal={setBoatDestinationModal}
        setSelectedDestIds={setSelectedDestIds}
        onCloseDestModal={() => setDestinationModalOpen(false)}
        onCloseBoatDestModal={() => setBoatDestinationModal(null)}
        onCreateDestination={createDestination}
        onToggleBoatDestination={toggleBoatDestination}
        onSaveBoatDestinations={saveBoatDestinations}
      />

      <AddAmenityModal
        amenityModalOpen={amenityModalOpen}
        newAmenityName={newAmenityName}
        boatAmenityModal={boatAmenityModal}
        selectedAmenityIds={selectedAmenityIds}
        allGlobalAmenities={allGlobalAmenities}
        setNewAmenityName={setNewAmenityName}
        setBoatAmenityModal={setBoatAmenityModal}
        setSelectedAmenityIds={setSelectedAmenityIds}
        onCloseAmenityModal={() => { setAmenityModalOpen(false); setNewAmenityName(""); }}
        onCloseBoatAmenityModal={() => setBoatAmenityModal(null)}
        onCreateAmenity={createAmenity}
        onToggleBoatAmenity={toggleBoatAmenity}
        onSaveBoatAmenities={saveBoatAmenities}
      />

      <VerifyBookingModal
        booking={verifyBooking}
        onClose={() => setVerifyBooking(null)}
        onUpdated={handleVerificationUpdated}
        notifySuccess={notifySuccess}
        notifyFailure={notifyFailure}
        slotText={slotText}
      />

      <AddActivityModal
        open={activityModalOpen}
        onClose={() => setActivityModalOpen(false)}
        onChanged={fetchActivities}
      />

      <Footer />
    </>
  );
}

export default DashBoard;
